import {Component, forwardRef, HostBinding, Input, OnInit} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {IonToggleBaseComponent} from '../../../core/ion-components/ionToggle';

@Component({
  selector: 'app-toggle',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleComponent),
      multi: true
    }
  ]
})

/**
 * Usage:
 * ```
 * ```
 *
 * Configurable params:
 *  - type
 */
export class ToggleComponent extends IonToggleBaseComponent implements OnInit {

  @Input() labelText?: string = null;
  @Input() optionText?: string = null;
  @Input() requiredLabel = false;

  // @todo add debounce, for toggles on the lists

  @HostBinding('class')
  get classes() {
    return {};
  }

  get value(): (number | boolean) {

    if (typeof this._value === 'string') {
      this._value = parseInt(this._value, 10);
    }

    return this._value ? 1 : 0;
  }

  @Input() set value(value: (number | boolean)) {
    this._value = value;
    this.notifyValueChange();
  }

  onChange(event) {
    this.value = event.detail.checked;
  }

  ngOnInit() {
    setTimeout(() => {

      // eto pizdec
      if (typeof this.value === 'string') {
        this.value = parseInt(this.value, 10);
      }

      this.value = !!this.value;
    }, 10);
  }
}
